// GO4S — reprise des couleurs d'une autre école du complexe.
// Un clic recopie la paire primaire/secondaire dans les deux champs du
// formulaire, au lieu de les ressaisir établissement par établissement.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  pick({ params, currentTarget }) {
    this.assign("school_primary_color", params.primary);
    this.assign("school_secondary_color", params.secondary);

    this.element
      .querySelectorAll(".ds-reuse-thumb--active")
      .forEach((el) => el.classList.remove("ds-reuse-thumb--active"));
    currentTarget.classList.add("ds-reuse-thumb--active");
  }

  assign(id, value) {
    if (!value) return;
    const field = document.getElementById(id);
    if (!field) return;
    field.value = value;
    // Les sélecteurs de couleur n'écoutent pas l'affectation directe.
    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
